import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { displayToastSuccess } from '@/helpers/display-toast';
import { useApiError } from '@/modules/common/hooks/use-api-error';
import { invalidateUserGroupRelatedQueries } from '@/modules/common/utils/query-invalidation';

import { renameUserGroup } from '../../api/user-groups.api';

export const useRenameUserGroup = ({ onSuccess }: { onSuccess?: () => void } = {}) => {
  const queryClient = useQueryClient();
  const { t } = useTranslation('authenticated.settings');
  const { displayToastErrorFromApiWithFallback } = useApiError();

  return useMutation({
    mutationFn: renameUserGroup,
    onSuccess: async (_data, variables) => {
      // Awaited before the toast and `onSuccess` — see the create hook.
      await invalidateUserGroupRelatedQueries(queryClient);
      displayToastSuccess(t('pages.permissions.toasts.groupRenamed', { name: variables.name }));
      onSuccess?.();
    },
    onError: (error: unknown) =>
      displayToastErrorFromApiWithFallback(
        error,
        'authenticated.settings:api.error.userGroups.renameFailed'
      ),
  });
};
